import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Rent } from 'store/transferAct/actions';
import { useDispatch } from 'react-redux';

import { convertNumber, getUnixTimestamp } from 'helpers/utils';

import { InfoCard, InfoCardIcon, InfoCardBlock, InfoCardLink, InfoCardComment } from 'components/InfoCard';

const InfoCardsSection = ({ rent, stock, showEmpty, canDelete }) => {
  const dispatch = useDispatch();

  const [cardPending, setCardPending] = useState(true);

  useEffect(() => {
    if (rent) {
      setCardPending(false);
    } else {
      setCardPending(true);
    }
  }, [rent]);

  const deleteFine = (fronEndID) => {
    dispatch(Rent.updateRent({ fine: rent.fine.filter((elem) => elem.fronEndID != fronEndID) }));
  };

  const deleteDiscount = (fronEndID) => {
    dispatch(Rent.updateRent({ discount: rent.discount.filter((elem) => elem.fronEndID != fronEndID) }));
  };

  return (
    <div className="rent-section">
      <InfoCard title="Клиент" pending={cardPending} showCard={!!showEmpty} showContent={!!rent?.client}>
        <InfoCardBlock title="ФИО" text={rent?.client?.FIO} />

        <InfoCardBlock title="Номер" text={convertNumber(rent?.client?.PhMain)} />
        <InfoCardLink
          title="Перейти в профиль"
          link={{
            url: `/client/${rent?.client?.id}`,
            params: {
              redirectFromRent: `/rent${rent.actID1C ? `/${rent.actID1C}` : ''}`,
            },
          }}
        />
      </InfoCard>

      <InfoCard
        title="Общее"
        pending={cardPending}
        showCard={!!showEmpty}
        showContent={!!stock || !!rent?.agr || !!rent?.endDateTime}
      >
        {rent?.agr && <InfoCardBlock title="ФОП" text={rent.agr.organization.orgName} />}

        {stock && <InfoCardBlock title="Склад" text={stock?.stockName} />}

        {rent && rent.endDateTime > 0 && (
          <InfoCardBlock
            title="Срок"
            text={`${Math.round((rent.endDateTime - (rent.startDateTime || getUnixTimestamp())) / 86400)} сут.`}
          />
        )}
      </InfoCard>

      <InfoCard title="Бонусы" showCard={!!showEmpty} showContent={!!rent?.client} pending={cardPending}>
        <InfoCardBlock title="Начислено" text={`${rent?.bonusAccured || 0} грн.`} />

        <InfoCardBlock title="Списано" text={`${rent?.bonusSpent || 0} грн.`} />

        <InfoCardBlock title="Остаток" text={`${rent?.client?.bonusAccount || 0} грн.`} />
      </InfoCard>

      <InfoCard title="Комментарий" showCard={!!showEmpty} showContent={!!rent?.comment} pending={cardPending}>
        {rent?.comment}
      </InfoCard>

      {rent?.fine.map((elem) => {
        return (
          <InfoCardIcon
            title="Штраф"
            key={elem.fronEndID}
            pending={cardPending}
            showCard={!!showEmpty}
            showContent
            icon={elem.conduct && <div className="c1-button">1C</div>}
          >
            {canDelete && !elem.conduct && (
              <div className="wrap-btn-icon-delete">
                <div className="delete-icon" onClick={() => deleteFine(elem.fronEndID)}>
                  <div className="icon-trash-svg" />
                </div>
              </div>
            )}
            <InfoCardBlock title="Статья" text={elem.accrualSubType?.name} />

            <InfoCardBlock title="Сумма" text={`${elem.sum} грн.`} />

            <InfoCardComment text={elem.comment || ''} />
          </InfoCardIcon>
        );
      })}

      {rent?.discount.map((elem) => {
        return (
          <InfoCardIcon
            key={elem.fronEndID}
            title="Скидка"
            pending={cardPending}
            showCard={!!showEmpty}
            showContent
            icon={elem.conduct && <div className="c1-button">1C</div>}
          >
            {canDelete && !elem.conduct && (
              <div className="wrap-btn-icon-delete">
                <div className="delete-icon" onClick={() => deleteDiscount(elem.fronEndID)}>
                  <div className="icon-trash-svg" />
                </div>
              </div>
            )}
            <InfoCardBlock title="Статья" text={elem.accrualSubType?.name} />

            <InfoCardBlock title="Сумма" text={`${elem.sum} грн.`} />

            <InfoCardComment text={elem.comment || ''} />
          </InfoCardIcon>
        );
      })}

      <InfoCard title="Адрес" showCard={!!showEmpty} showContent={!!rent.address} pending={cardPending}>
        {rent.address}
      </InfoCard>
    </div>
  );
};

InfoCardsSection.propTypes = {
  rent: PropTypes.any,
  stock: PropTypes.any,
  showEmpty: PropTypes.bool,
  canDelete: PropTypes.bool,
};

InfoCardsSection.defaultProps = {
  rent: null,
  stock: null,
  showEmpty: true,
  canDelete: false,
};

export { InfoCardsSection };
